// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import { getConfig } from '../../config';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const VendorActivitiesList = ({ activities }) => {
  const config = getConfig();

  const onRowClick = id => {
    const url = `${config.batchAdminURL}/experiences/${id}`;
    window.open(url, '_blank');
  };

  return (
    <div>
      <Table hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>City</th>
            <th>Hidden</th>
            <th>Bookable</th>
            <th>Cancellation Policy</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {activities.map(item => (
            <tr key={item.id} onClick={() => onRowClick(item.id)}>
              <td>{item.title}</td>
              <td>{item.type}</td>
              <td>{item.city}</td>
              <td>{item.tags.includes('hidden') ? 'Yes' : 'No'}</td>
              <td>{item.bookable ? 'Yes' : 'No'}</td>
              <td>{item.cancellationPolicy}</td>
              <td
                onClick={event => {
                  event.stopPropagation();
                }}
              >
                <a href={`/activities/${item.id}`}>Open in BAT</a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default VendorActivitiesList;
